import { render, staticRenderFns } from "./WidgetsDropdown.vue?vue&type=template&id=30864194&"
import script from "./WidgetsDropdown.vue?vue&type=script&lang=js&"
export * from "./WidgetsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\yuichi\\git\\open_coupon\\public\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30864194')) {
      api.createRecord('30864194', component.options)
    } else {
      api.reload('30864194', component.options)
    }
    module.hot.accept("./WidgetsDropdown.vue?vue&type=template&id=30864194&", function () {
      api.rerender('30864194', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/widgets/WidgetsDropdown.vue"
export default component.exports